export function PatientSex3 (gender){
    if (gender === true){
        return PatientSex[1]
    } else if (gender === false){
        return PatientSex[0]
    } else {
        return PatientSex[2]
    }
}


export function PatientSex2 (gender){
    if ((gender === 0)||(gender === 1)){
        return PatientSex[gender];
    } else {
        return PatientSex[2];
    }
}


const PatientSex = {
    0: 'female',
    1: 'male',
    2: 'others',
};

export default PatientSex;